import React from "react";


const badgeStyles = {
    green: {classes: "bg-green-900 text-green-400 border-green-950",},
    new: {classes: "bg-[#3f2409] text-[#bf930f]",},
    warning: {classes: "bg-yellow-950 text-yellow-500 border-yellow-800",},
    discount : {classes: "bg-[#ffadc1] text-[#72001a] border-transparent"}
};

type BadgeVariant = keyof typeof badgeStyles; 

interface LabelProps {
    variant: BadgeVariant;
    children: React.ReactNode;
    className? : string;
}

export const Label = ({ variant, children, className }: LabelProps) => {
    const style = badgeStyles[variant];
    const baseClasses = "text-xs rounded-lg text-center px-2 py-1 font-medium";
    const finalClassName = `${baseClasses} ${style.classes} ${className || ''}`;
    return (
        <p className={finalClassName}>
            {children}
        </p>
    );
};







